import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OAuthModule } from 'angular-oauth2-oidc';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    // No `resourceServer` config: that only configures angular-oauth2-oidc's
    // DefaultOAuthInterceptor, which is registered through HTTP_INTERCEPTORS and
    // is therefore never applied — provideHttpClient() in app.config.ts does not
    // pass withInterceptorsFromDi(). Tokens are attached by our own functional
    // tokenInterceptor, which does not consult an allowed-URL list.
    OAuthModule.forRoot()
  ],
  exports: [
    OAuthModule
  ]
})
export class AuthModule { } 